import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";


interface PropsValue {
    value: models.CargaDescargaEADDto;
}

const Info = (x: { label: string, data: any }) =>
    <span>
        <label>{x.label}{":"}</label>
        {" "}{kea.cellToText(x.data)}
    </span>;

class CargaDescargaInfoValueNoRx extends React.PureComponent<PropsValue> {
    render() {
        const x = this.props.value;
        return (
            <kea.Panel title="Información">
                {kea.autogrid(3, [
                    <Info label="Folio" data={x.Folio} />,
                    <Info label="Status" data={models.StatusCargaDescarga[x.Status]} />,
                    <Info label="Camión" data={x.NombreCamion} />,
                    <Info label="Sucursal" data={x.NombreSucursal} />,
                    <Info label="Chofer" data={x.NombreChofer} />,
                    <Info label="usuario" data={x.NombreUsuario} />,
                    <Info label="Ruta" data={x.NombreRutaEAD} />,
                    <Info label="Tiene servicios incluídos" data={x.TieneServiciosIncluidos} />,
                    <Info label="Tiene guias incompletas" data={x.TieneGuiasIncompletas} />,
                ])
                }
            </kea.Panel>
        )
    }
}

const CargaDescargaInfoValue = componentToRx(CargaDescargaInfoValueNoRx);

interface Props {
    idCargaDescarga: number;
}

/**Muestra la información de una carga/descarga reaccionando a los cambios del resource */
export class CargaDescargaInfo extends React.PureComponent<Props> {
    id = (props: Props) => props.idCargaDescarga;
    info = createSelectorRx(this.id, id => observeResource(resources.CargaDescargaEAD.Get, id));
    render() {
        return <CargaDescargaInfoValue value={this.info(this.props)} />
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasEAD/edit/info.tsx